import { ScrambleExternalLink } from "@/components/custom/scramble-animation/scramble-external-link"
import { ScrambleFastLink } from "@/components/custom/scramble-animation/scramble-fast-link"
import { cn } from "@/lib/utils"
import { DotsPattern } from "./dots-pattern"

export function DesktopNavButton({
    text,
    href,
    iconElement,
    className,
    textContainerClassName,
    withDotsBackground = true,
    isExternal = false,
}: {
    text: string
    href: string
    withDotsBackground?: boolean
    iconElement?: React.ReactNode
    className?: string
    textContainerClassName?: string
    isExternal?: boolean
}) {
    const Slot = isExternal ? ScrambleExternalLink : ScrambleFastLink
    return (
        <Slot
            text={text.toUpperCase()}
            uppercase={true}
            href={href}
            className={cn(
                "group relative flex h-full items-center justify-center gap-2 text-xs transition-colors duration-500 hover:bg-white/3",
                className,
            )}
            textContainerClassName={cn(
                "absolute inset-0 flex items-center justify-center",
                iconElement && "pe-7",
                textContainerClassName,
            )}
        >
            <span className={cn("flex items-center gap-3 opacity-[0.01]")}>
                {text.toUpperCase()}
            </span>
            {iconElement}
            {withDotsBackground && (
                <DotsPattern className="absolute inset-0 opacity-0 transition-opacity duration-1000 group-hover:opacity-100" />
            )}
        </Slot>
    )
}
